import React, { useState, useEffect } from 'react';
import HMSNavbar from './HMSNavbar';
import NotificationBell from './NotificationBell';
import ReadingTray from './ReadingTray';
import './HMSNavbarWrapper.css';

/**
 * HMS Navbar Wrapper Component
 * Complete navbar solution with hamburger menu and overlay for mobile
 * Desktop collapsible navbar that overlays content when expanded
 * 
 * Props:
 * - children: React nodes - main content to display
 * - className: string - additional CSS classes for main content
 */
function HMSNavbarWrapper({ children, className = '' }) {
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(true); // Desktop collapse state

  const toggleNavbar = () => {
    setIsNavbarOpen(!isNavbarOpen);
  };

  const closeNavbar = () => {
    setIsNavbarOpen(false);
  };

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (isNavbarOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isNavbarOpen]);

  return (
    <div className="hms-navbar-wrapper-container">
      {/* Global notification bell — always visible on every Layout screen
          (Jonas feedback 19.08: easier access to notifications) */}
      <NotificationBell />

      {/* Documents this person started reading that are still going - a way back
          to their progress after closing the window or refreshing. */}
      <ReadingTray />

      {/* Hamburger Menu Button */}
      <button
        className={`hms-navbar-hamburger ${isNavbarOpen ? 'open' : ''}`}
        onClick={toggleNavbar}
        aria-label="Toggle navigation menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      {/* Overlay for mobile */}
      {isNavbarOpen && (
        <div 
          className="hms-navbar-overlay show" 
          onClick={closeNavbar}
        ></div>
      )}

      {/* Navbar Sidebar */}
      <HMSNavbar 
        isOpen={isNavbarOpen} 
        onClose={closeNavbar}
        isCollapsed={isCollapsed}
        onToggleCollapse={toggleCollapse}
      />

      {/* Main Content */}
      <main className={`hms-navbar-main-content ${isCollapsed ? 'navbar-collapsed' : 'navbar-expanded'} ${className}`}>
        {children}
      </main>
    </div>
  );
}

export default HMSNavbarWrapper;

